import { Payment, useWatchForTransaction } from "@/api/payment-pages"
import Loader from "@/components/layout/loader"
import { useEffect } from "react"
import { Transaction } from "@/api/transactions"

interface PayFlowProps {
  shortId: string;
  payment: Payment;
  onConfirmed: (transaction: Transaction) => void;
  transactionId: string;
}

export default function PayWithBalanceConfirm({
  shortId,
  payment,
  transactionId,
  onConfirmed,
}: PayFlowProps) {
  const transaction = useWatchForTransaction(
    shortId,
    payment.id,
    transactionId,
  )

  useEffect(() => {
    if (transaction) {
      onConfirmed(transaction)
    }
  }, [transaction, onConfirmed])

  if (!transaction) {
    return <Loader message="Waiting for transaction to be confirmed..." />
  }
}
